module.exports = __webpack_public_path__ + "media/images/athletes/2874-5aeb03d67a1c5abda2d01822dfa4ed9d.png";